import { c as _c } from "react/compiler-runtime";
import { IcoInfo16 } from '@onefootprint/icons';
import type { DataIdentifier, DocumentKind } from '@onefootprint/request-types/dashboard';
import { LinkButton, LoadingSpinner, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useCurrentEntity from '@/entities/components/details/hooks/use-current-entity';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import type { EntityVault } from '@/types/vault';
import getRelevantNonDocumentKeys from '../../../utils/get-relevant-non-document-keys';
type DecryptProps = {
  canDecrypt: boolean;
  onDecryptSuccess: (vault: VaultType) => void;
  documentType: DocumentKind;
  vaultData: VaultType | undefined;
  seqno: string | undefined;
};
const Decrypt = t0 => {
  const $ = _c(18);
  const {
    canDecrypt,
    onDecryptSuccess,
    documentType,
    vaultData,
    seqno
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.identity.decrypt"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    data: entity
  } = useCurrentEntity();
  const decryptControls = useDecryptControls();
  let t2;
  if ($[1] !== documentType || $[2] !== vaultData?.vault) {
    const relevantKeys = getRelevantNonDocumentKeys(documentType);
    t2 = Object.keys(vaultData?.vault || {}).filter(key => relevantKeys.includes(key as DataIdentifier));
    $[1] = documentType;
    $[2] = vaultData?.vault;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== canDecrypt || $[5] !== decryptControls || $[6] !== documentType || $[7] !== entity || $[8] !== onDecryptSuccess || $[9] !== seqno || $[10] !== t || $[11] !== t2) {
    const fields = t2.map(key_0 => `${key_0}${seqno ? `:${seqno}` : ""}` as DataIdentifier);
    const handleDecryptSubmit = async () => {
      if (!entity) {
        return;
      }
      const response = await decryptControls.decrypt({
        entity,
        fields,
        reason: `Examining document ${documentType}`
      });
      const vault = Object.entries(response ?? {}).reduce((acc, t4) => {
        const [key_1, value] = t4;
        const di = seqno ? key_1.split(":")[0] : key_1;
        acc[di] = value;
        return acc;
      }, {} as EntityVault);
      onDecryptSuccess({
        vault,
        transforms: {}
      });
    };
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <IcoInfo16 color="tertiary" />;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== t) {
      t6 = t(_temp);
      $[14] = t;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] !== t6) {
      t7 = <div className="flex gap-2 items-center">{t5}<p className="text-body-2 text-tertiary">{t6}</p></div>;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t3 = <div className="flex justify-between items-center">{t7}{decryptControls.isDecrypting(fields) ? <LoadingSpinner /> : <Tooltip disabled={canDecrypt} content={t(_temp2)}><LinkButton disabled={!canDecrypt} onClick={handleDecryptSubmit} className="underline">{t(_temp3)}</LinkButton></Tooltip>}</div>;
    $[4] = canDecrypt;
    $[5] = decryptControls;
    $[6] = documentType;
    $[7] = entity;
    $[8] = onDecryptSuccess;
    $[9] = seqno;
    $[10] = t;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default Decrypt;
function _temp($) {
  return $.text;
}
function _temp2($_0) {
  return $_0.notAllowed;
}
function _temp3($_1) {
  return $_1.decryptAll;
}